import React, { useState } from "react";
import { NavLink } from "react-router-dom";
import CancelIcon from "../../../assets/icons/cancel icon-01.svg";
import menuIcon from "../../../assets/icons/menu.svg";
const Sidebar = ({ setShowSidbarMarginLeft }) => {
  const [showSidebar, setShowSidebar] = useState(false);

  return (
    <>
      {showSidebar ? (
        <button
          className="flex text-[12px] items-center cursor-pointer fixed left-6 top-5 z-50  screen400:left-4"
          onClick={() => {
            setShowSidebar(!showSidebar);
            setShowSidbarMarginLeft(!showSidebar);
          }}
        >
          <img
            className="w-4 h-4  my-2 screen800:my-1  screen500:my-0 screen800:w-3 screen500:w-3"
            width={16}
            height={16}
            src={CancelIcon}
            alt="بستن"
          />
        </button>
      ) : (
        <img
          alt="منو صرافی روبین"
          onClick={() => {
            setShowSidebar(!showSidebar);
            setShowSidbarMarginLeft(!showSidebar);
          }}
          className="absolute z-30  items-center cursor-pointer left-35 top-4 w-10 h-10 
          screen500:w-6 screen500:h-6 screen500:top-4 screen1000:w-8 screen1000:h-8 screen1800:w-14 screen1800:h-14"
          src={menuIcon}
        />
      )}

      <div
        onClick={() => {
          setShowSidebar(!showSidebar);
          setShowSidbarMarginLeft(!showSidebar);
        }}
        className={`top-0 left-0 w-[135px]  px-2 text-center  h-screen  bg-[#606161]   fixed  z-40  ${
          showSidebar
            ? "transition duration-1000 ease-in-out -translate-x-0 "
            : "transition duration-1000 ease-in-out -translate-x-full"
        }`}
      >
        <ul
          className="grid grid-cols-1  justify-center mt-10  py-3 text-[16px] text-white  duration-700 font-bold screen800:text-[14px] screen500:text-[11px] screen1800:text-[23px]
        "
        >
          <NavLink
            onClick={() => {
              setShowSidebar(!showSidebar);
              setShowSidbarMarginLeft(!showSidebar);
            }}
            className={({ isActive }) => (isActive ? "text-[#66cc33]" : "")}
            to="/"
          >
            <li className="text-center  mx-4">خانه</li>
          </NavLink>

          <NavLink
            onClick={() => {
              setShowSidebar(!showSidebar);
              setShowSidbarMarginLeft(!showSidebar);
            }}
            className={({ isActive }) => (isActive ? "text-[#66cc33]" : "")}
            to="/gallery"
          >
            <li className="text-center my-3 ">گالری</li>
          </NavLink>
          <NavLink
            onClick={() => {
              setShowSidebar(!showSidebar);
              setShowSidbarMarginLeft(!showSidebar);
            }}
            className={({ isActive }) => (isActive ? "text-[#66cc33]" : "")}
            to="/forms"
          >
            <li className=" text-center my-3 mx-4">فرم ها</li>
          </NavLink>
          <NavLink
            onClick={() => {
              setShowSidebar(!showSidebar);
              setShowSidbarMarginLeft(!showSidebar);
            }}
            className={({ isActive }) => (isActive ? "text-[#66cc33]" : "")}
            to="/queue-sysem"
          >
            <li className=" text-center my-3 mx-4">نوبت دهی</li>
          </NavLink>

          <NavLink
            className={({ isActive }) => (isActive ? "text-[#66cc33]" : "")}
            to="/comment"
          >
            <li className="p-6 screen700:p-3 screen500:p-2 screen400:p-1">
              ثبت نظر
            </li>
          </NavLink>
          <NavLink
            onClick={() => {
              setShowSidebar(!showSidebar);
              setShowSidbarMarginLeft(!showSidebar);
            }}
            className={({ isActive }) => (isActive ? "text-[#66cc33]" : "")}
            to="/about-us"
          >
            <li className="text-center my-3 mx-4">درباره ی ما</li>
          </NavLink>
        </ul>
      </div>
    </>
  );
};

export default Sidebar;
